import React, { useCallback, useEffect, useState } from 'react'
import { Button } from '@/components/atoms'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

interface SaveDraftConfirmDialogProps {
  onOk: () => Promise<void>
  when: boolean
}
export const SaveDraftConfirmDialog: React.FC<SaveDraftConfirmDialogProps> = ({ onOk, when }) => {
  const [showPrompt, setShowPrompt] = useState(false)
  const [currentPath, setCurrentPath] = useState('')

  const { t } = useTranslation()

  const history = useHistory()

  useEffect(() => {
    if (when) {
      history.block((location, action) => {
        if (action === 'POP') {
          setCurrentPath(location.pathname)
          setShowPrompt(true)
          return false
        }
      })
    }

    return () => {
      history.block(() => {})
    }
  }, [history, when])

  const handleOK = useCallback(async () => {
    await onOk()
    history.block(() => {})
    history.push(currentPath)
  }, [currentPath, history, onOk])

  const handleCancel = useCallback(() => {
    history.block(() => {})
    history.push(currentPath)
  }, [currentPath, history])

  return showPrompt ? (
    <>
      <div css={modalBackgroundStyle} />
      <div css={modalStyle}>
        <p>{t('Do you want to save the draft?')}</p>
        <div className="button-area">
          <Button width={110} height={38} buttonType={3} fontSize={12} onClick={() => handleCancel()}>
            {t('No')}
          </Button>
          <Button width={110} height={38} buttonType={1} fontSize={12} onClick={() => handleOK()}>
            {t('Save')}
          </Button>
        </div>
      </div>
    </>
  ) : (
    <></>
  )
}

const modalStyle = css({
  height: 176,
  width: 400,
  position: 'fixed',
  zIndex: 1000,
  background: '#FFFFFF',
  top: 'calc(-50vh + 100% - 176px / 2)',
  left: 'calc(-50vw + 100% - 400px / 2)',
  padding: '40px',
  borderRadius: 5,
  p: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 18,
    letterSpacing: 0.9,
    whiteSpace: 'pre-wrap',
    lineHeight: '27px',
  },
  '.button-area': {
    display: 'flex',
    justifyContent: 'center',
    gap: '24px',
    paddingTop: 24,
  },
})

const modalBackgroundStyle = css({
  background: '#272727',
  width: '100vw',
  height: '100vh',
  position: 'fixed',
  zIndex: 999,
  top: 'calc(-100vh + 100%)',
  left: 'calc(-100vw + 100%)',
  opacity: 0.5,
})
